export const POSITIVE_WATER_LABEL = 'Positivo'
export const NEGATIVE_WATER_LABEL = 'Negativo'
export const PRUEBA_POSITIVA_STATE = 2
